/* NIBBLE & NABBLE 2.1 — shop selector, hidden 7, video, parallax (editor-safe) */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Mood chips + product strip filtering ── */
  function initShop(scope) {
    (scope || document).querySelectorAll('[data-nn-shop]:not([data-shop-init])').forEach(function (root) {
      root.dataset.shopInit = '1';
      var strip = root.querySelector('[data-nn-strip]');
      var empty = root.querySelector('[data-nn-empty]');
      if (!strip) return;
      var items = Array.prototype.slice.call(strip.querySelectorAll('.nn-shop__strip-item'));

      root.addEventListener('click', function (e) {
        var surprise = e.target.closest('[data-nn-surprise]');
        if (surprise) {
          var visible = items.filter(function (i) { return !i.classList.contains('nn-filter-hide'); });
          var pool = visible.length ? visible : items;
          if (!pool.length) return;
          var pick = pool[Math.floor(Math.random() * pool.length)];
          pick.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center', inline: 'center' });
          pick.classList.add('nn-shop__strip-item--picked');
          setTimeout(function () {
            pick.classList.remove('nn-shop__strip-item--picked');
            var url = pick.dataset.url;
            if (url) window.location.href = url;
          }, 1100);
          return;
        }

        var chip = e.target.closest('.nn-mood[data-mood]');
        if (!chip) return;
        root.querySelectorAll('.nn-mood').forEach(function (m) { m.classList.remove('active'); });
        chip.classList.add('active');
        var mood = chip.dataset.mood;
        var shown = 0;
        items.forEach(function (item, idx) {
          var tags = (item.dataset.tags || '').split(' ');
          var show = mood === 'all' || tags.indexOf(mood) !== -1;
          item.classList.toggle('nn-filter-hide', !show);
          if (show) {
            shown++;
            if (!reduced) {
              item.style.transitionDelay = (Math.min(idx, 8) * 40) + 'ms';
              item.classList.remove('nn-pop-in'); void item.offsetWidth; item.classList.add('nn-pop-in');
            }
          }
        });
        if (empty) empty.hidden = shown !== 0;
      });
    });
  }

  /* ── Hidden 7 flavor chips ── */
  function initFlavors(scope) {
    (scope || document).querySelectorAll('[data-nn-flavors]:not([data-flavors-init])').forEach(function (wrap) {
      wrap.dataset.flavorsInit = '1';
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('a')) return; /* let flavor links navigate */
        var btn = e.target.closest('.nn-flavor');
        if (!btn) return;
        var wasOpen = btn.classList.contains('open');
        wrap.querySelectorAll('.nn-flavor').forEach(function (f) {
          f.classList.remove('open');
          f.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          btn.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── Video: swap poster for iframe on play ── */
  function embedUrl(url) {
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{6,})/);
    if (yt) return 'https://www.youtube-nocookie.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vm = url.match(/vimeo\.com\/(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }
  function initVideo(scope) {
    (scope || document).querySelectorAll('[data-nn-video]:not([data-video-init])').forEach(function (v) {
      v.dataset.videoInit = '1';
      var btn = v.querySelector('.nn-video__play');
      btn && btn.addEventListener('click', function () {
        var src = embedUrl(v.dataset.videoUrl || '');
        if (!src) return;
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Our story video');
        v.classList.add('nn-video--playing');
        v.appendChild(iframe);
      });
    });
  }

  /* ── Gentle hero parallax ── */
  function initParallax() {
    if (reduced) return;
    var el = document.querySelector('[data-nn-parallax] img');
    if (!el) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY * 0.12, 80);
        el.style.transform = 'translateY(' + y + 'px) scale(1.06)';
        ticking = false;
      });
    }, { passive: true });
  }

  function boot() { initShop(); initFlavors(); initVideo(); initParallax(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { initShop(e.target); initFlavors(e.target); initVideo(e.target); });
})();
